import {FeatureModule} from '../model/license/feature-module';
import {FeatureTemplate} from '../model/license/feature-template.model';
import {FeatureType} from '../model/license/feature-type';

export namespace SortingUtils {
  export const createModuleParents = (featureTemplates: FeatureTemplate[]): FeatureTemplate[] =>
    Array.from(new Set(featureTemplates.map(it => it.featureModule)))
      .map(module => ({
        id: `module-header-${module}`,
        featureModule: module,
        featureType: module as unknown as FeatureType,
        enabled: false,
        deliveryDate: null as unknown as string,
        activationCost: 0,
        version: 0,
      }));

  export const sortFeatureTemplatesByModulePriority = (
    templates: FeatureTemplate[],
    priorityOrderArg: FeatureModule[] = priorityOrder
  ): FeatureTemplate[] => {
    const priorityMap = new Map(
      priorityOrderArg.map((module, index) => [module, index])
    );

    return templates.slice().sort((a, b) => {
      const priorityA = priorityMap.get(a.featureModule) ?? Number.MAX_SAFE_INTEGER;
      const priorityB = priorityMap.get(b.featureModule) ?? Number.MAX_SAFE_INTEGER;
      return priorityA - priorityB;
    });
  };

  // Jeden wiersz-naglowek na modul. Preferujemy "bramke" (featureType == featureModule, np. SUPPORT),
  // a dla modulow bez bramki (ORDERS/CRM/SRM po konsolidacji) bierzemy pierwszy feature z modulu.
  export const pickModuleHeaderRows = (templates: FeatureTemplate[]): FeatureTemplate[] => {
    const headerByModule = new Map<FeatureModule, FeatureTemplate>();
    for (const it of templates) {
      const isGate = (it.featureType as unknown as FeatureModule) === it.featureModule;
      const current = headerByModule.get(it.featureModule);
      if (current === undefined || (isGate && (current.featureType as unknown as FeatureModule) !== current.featureModule)) {
        headerByModule.set(it.featureModule, it);
      }
    }
    return sortFeatureTemplatesByModulePriority(Array.from(headerByModule.values()));
  };

  const priorityOrder: FeatureModule[] = [
    FeatureModule.SUPPORT,
    FeatureModule.AGENT,
    FeatureModule.MARKETING,
    FeatureModule.MASSIVE_FILES,
    FeatureModule.PRODUCT,
    FeatureModule.ORDERS,
    FeatureModule.CRM,
    FeatureModule.SRM,
    FeatureModule.ANALYTICS,
    FeatureModule.STORAGE_MODULE,
    FeatureModule.INTEGRATIONS_MODULE,
  ];
}
